import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../style/onboarding2.css";

const CONTENT_TYPES = [
  { value: "informative", label: "Informative Blog Post" },
  { value: "promotional", label: "Promotional Article" },
  { value: "creative",    label: "Creative Writing" },
];
const TONES = [
  { value: "formal",    label: "Formal" },
  { value: "friendly",  label: "Friendly" },
  { value: "persuasive",label: "Persuasive" },
];
const LENGTHS = [
  { value: "short",  label: "Short (300–500 words)" },
  { value: "medium", label: "Medium (600–900 words)" },
  { value: "long",   label: "Long (1000–1500 words)" },
];

export default function OnboardingStep3() {
  const navigate = useNavigate();
  const location = useLocation();

  const carried = useMemo(() => {
    const s = location.state || {};
    if (Object.keys(s).length) return s;
    try {
      const brand = localStorage.getItem("onboarding.brand");
      return brand ? JSON.parse(brand) : {};
    } catch {
      return {};
    }
  }, [location.state]);

  const [contentType, setContentType] = useState("informative");
  const [tone, setTone] = useState("friendly");
  const [length, setLength] = useState("medium");

  function handleBack() {
    navigate("/onboarding/step-2", { state: carried });
  }

  function handleNext() {
    const settings = { contentType, tone, length };
    localStorage.setItem("onboarding.settings", JSON.stringify(settings));
    // Let <RequireAuth> guard /generation handle auth redirects
    navigate("/generation", { replace: true });
  }

  const prettyType = CONTENT_TYPES.find(x => x.value === contentType)?.label || "";
  const prettyTone = TONES.find(x => x.value === tone)?.label.toLowerCase() || "";
  const prettyLen  = LENGTHS.find(x => x.value === length)?.label || "";

  return (
    <div className="page-wrap">
      <aside className="left-panel">
        <div className="left-card">
          <h1 className="title">Content<br/>Settings</h1>
          <p className="subtitle">
            You’ve selected a <strong>{prettyType}</strong> in a <strong>{prettyTone}</strong> tone with a <strong>{prettyLen}</strong>.
          </p>
        </div>
      </aside>

      <main className="right-panel">
        <form className="form-area" onSubmit={(e) => e.preventDefault()}>
          <div className="branding-section">
            <div className="section-title">Content type</div>
            <div className="brand-card" style={{ gridTemplateColumns: "160px 1fr" }}>
              <div className="brand-left"><div className="brand-label">Type</div></div>
              <div className="brand-right">
                <select className="input" value={contentType} onChange={e => setContentType(e.target.value)}>
                  {CONTENT_TYPES.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
              </div>
            </div>

            <div className="section-title" style={{ marginTop: 16 }}>Tone</div>
            <div className="brand-card" style={{ gridTemplateColumns: "160px 1fr" }}>
              <div className="brand-left"><div className="brand-label">Tone</div></div>
              <div className="brand-right">
                <select className="input" value={tone} onChange={e => setTone(e.target.value)}>
                  {TONES.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
              </div>
            </div>

            <div className="section-title" style={{ marginTop: 16 }}>Length</div>
            <div className="brand-card" style={{ gridTemplateColumns: "160px 1fr" }}>
              <div className="brand-left"><div className="brand-label">Words</div></div>
              <div className="brand-right">
                <select className="input" value={length} onChange={e => setLength(e.target.value)}>
                  {LENGTHS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn outline-pill" onClick={handleBack}>Back</button>
            <button type="button" className="btn primary-pill" onClick={handleNext}>Next</button>
          </div>
        </form>
      </main>
    </div>
  );
}
